import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { KnowledgePageLoadingSkeleton } from '@jira/spa-apps__knowledge-page/src/KnowledgePageLoadingSkeleton.tsx';
import { KnowledgePageEntryPoint as main } from '@jira/spa-apps__knowledge-page/src/knowledgePage.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { softwareKnowledgeRoute } from '@jira/router-routes__software-knowledge-routes/src/softwareKnowledgeRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import type { Route } from '@atlassian/react-resource-router';

const softwareKnowledgeEntryPoint: ReturnType<typeof createPageEntryPoint> = createPageEntryPoint({
	main,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const softwareKnowledgeRouteEntry: Route = createEntry(softwareKnowledgeRoute, () => ({
	group: 'software',
	perfMetricKey: 'software.knowledge',
	layout: softwareProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [
		...getNavigationResources(),
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		projectThemeResource,
	],

	entryPoint: () =>
		expValEquals('jira-agent-context-experiment', 'isEnabled', true, false)
			? softwareKnowledgeEntryPoint
			: notFoundPageEntrypoint,
	forPaint: [LazyAtlassianNavigation],
	skeleton: KnowledgePageLoadingSkeleton,
	ufoName: 'software-knowledge',

	bifrost: {
		bifrostGroup: 'shell-only',
	},

	supportsProjectTheme: 'full',
}));
